import React from "react";
import carInFinalStageImg from "../../../../assets/images/keyless-return/rental-in-final-stage-img.svg";

export function RentalInFinalStage({t}) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        width: "100%",
        gap: "24px",
        padding: "24px 0",
      }}
    >
    

      <img
        src={carInFinalStageImg}
        alt="A terminar aluguer"
        className="return-image"
      />

      <div
        style={{
          fontSize: "15px",
          color: "#333",
          lineHeight: "1.4",
        }}
      >
        <span style={{ display: "block", marginBottom: "4px" }}>
          {t("keylessReturnPleaseWait")}
        </span>
        <span style={{ display: "block", fontWeight: "bold" }}>
          {t("keylessReturnProcessing")}
        </span>
      </div>
    </div>
  );
}
